import { el } from 'redom';

class Option {

  constructor() {

    this.el = el('option');

  }

  update(option) {

    this.el.textContent = option;

  }

}

export default Option;